import { render } from "./SuccessPaymentPage.vue?vue&type=template&id=76d5d0a6&scoped=true"
import script from "./SuccessPaymentPage.vue?vue&type=script&lang=js"
export * from "./SuccessPaymentPage.vue?vue&type=script&lang=js"

import "./SuccessPaymentPage.vue?vue&type=style&index=0&id=76d5d0a6&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-76d5d0a6"]])

export default __exports__